import api from '../api';

import type { QueryFunction } from '@tanstack/react-query';
import type { PaymentListType } from 'domains/payment-titles';

export const getPayments: QueryFunction<Omit<PaymentListType, 'success'>, ['payments']> = async ({
  pageParam = 1,
  meta = {
    limit: 12,
  },
}) => {
  const { data, pagination } = (await api
    .get(`/reseller/list/paymenttitles`, {
      params: {
        limit: meta.limit,
        page: pageParam,
        'payment-status': 'open',
        sort: 'dueDateAsc',
        type: 'bankBilling',
      },
    })
    .then((resp) => resp)) as PaymentListType;

  return {
    data,
    pagination,
  };
};
